"use client";

import React from "react";

type Props = {
    children: React.ReactNode;
    className?: string;
};

export function SoftGradientBackground({ children, className }: Props) {
    return (
        <div className={`relative isolate overflow-hidden ${className ?? ""}`}>
            <div aria-hidden className="pointer-events-none absolute inset-0">
                <div
                    className="absolute -top-1/3 left-1/2 size-[80vw] -translate-x-1/2 rounded-full opacity-30 blur-2xl will-change-transform"
                    style={{
                        background:
                            "radial-gradient(closest-side, rgba(99,102,241,0.55), transparent 60%)",
                        animation: "float1 12s ease-in-out infinite",
                    }}
                />
                <div
                    className="absolute top-1/2 -left-1/4 size-[60vw] -translate-y-1/2 rounded-full opacity-25 blur-2xl will-change-transform"
                    style={{
                        background:
                            "radial-gradient(closest-side, rgba(16,185,129,0.5), transparent 60%)",
                        animation: "float2 12s ease-in-out infinite",
                    }}
                />
                <div
                    className="absolute bottom-0 -right-34 size-[50vw] rounded-full opacity-22 blur-2xl will-change-transform"
                    style={{
                        background:
                            "radial-gradient(closest-side, rgba(236,72,153,0.45), transparent 60%)",
                        animation: "float3 6s ease-in-out infinite",
                    }}
                />
            </div>

            <div className="relative">{children}</div>

            <style jsx>{`
        @media (prefers-reduced-motion: reduce) {
          .will-change-transform {
            animation: none !important;
          }
        }
        @keyframes float1 {
          0%,
          100% {
            transform: translate(-50%, 0);
          }
          50% {
            transform: translate(-55%, 5%);
          }
        }
        @keyframes float2 {
          0%,
          100% {
            transform: translate(0, -50%);
          }
          50% {
            transform: translate(5%, -45%);
          }
        }
        @keyframes float3 {
          0%,
          100% {
            transform: translate(0, 0);
          }
          50% {
            transform: translate(-3%, 3%);
          }
        }
      `}</style>
        </div>
    );
}
